import React from "react";
import { filtersArray, getCompanyNameIfTryAndBuy } from "../utilities";
import { filterValues, isoCountries } from "../constants";

import { ChevronLeft, ChevronRight, X } from "react-feather";

// ** Reactstrap Imports
import { Button, Col, Row } from "reactstrap";

class IndexSelectedFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = { start: 0 };
  }

  componentDidUpdate({ filters }) {
    if (this.props.filters.length > filters.length && this.state.start) {
      this.setState({ start: this.state.start - 1 });
    }
  }

  render() {
    const platformName = {
      Youtube: "YouTube",
      Tiktok: "TikTok",
    };
    const { filters, dismissFilter } = this.props;
    const { start } = this.state;
    const selectedFilters = filtersArray(filters);
    if (selectedFilters.length === 0) return null;
    const overflow = selectedFilters.length - start > 2;
    return (
      <>
        <div className="IndexSelectedFiltersHeading">Filters</div>
        <div className="IndexSelectedFilters mb-1">
          {start ? (
            <ChevronLeft
              className="OverflowSelectedFilters PreviousFilter"
              onClick={() => this.setState({ start: this.state.start - 1 })}
            />
          ) : null}

          {selectedFilters.slice(start).map(({ key, value, subKey }) => (
            <Button.Ripple
              className="m-1"
              outline
              color="primary"
              size="md"
              key={value}
              onClick={dismissFilter(key, value, subKey)}
            >
              <div className="d-flex">
                <div style={{ color: "#000000" }}>
                  {filterValues[value] ||
                    isoCountries[value] ||
                    platformName[value] ||
                    getCompanyNameIfTryAndBuy(value)}
                </div>

                <div className="ms-1 align-self-center">
                  <X size={15} color="#000000" />
                </div>
              </div>
            </Button.Ripple>
          ))}
          {overflow ? (
            <ChevronRight
              className="OverflowSelectedFilters NextFilter"
              onClick={() => this.setState({ start: this.state.start + 1 })}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default IndexSelectedFilters;
